// Disabling the default form submission on legacy popups by pressing enter in a field.
// Pressing enter in field in a form with only 1 input will submit even when there is no submit button.
// We barely have forms with 1 input field, so we almost never have this issue, but there are a few (e.g. tag.php).
// So pressing enter will submit the form to the same page, which doesn't work.
const disableDefaultFormSubmission = (iframe: boolean) => {
  const form = iframe
    ? document.querySelector<HTMLIFrameElement>('.js-popup-iframe')?.contentWindow?.document.querySelector('form')
    : document.querySelector<HTMLFormElement>('.popup-without-iframe form');

  if (!form) {
    return;
  }

  form.addEventListener('submit', (event) => {
    event.preventDefault();
  });
};

export default disableDefaultFormSubmission;
